import { Tag } from "@arco-design/web-react";

import type { QuoteBudgetItinerarySummary } from "../types";
import { buildItineraryEditPath, buildItineraryPreviewPath } from "../../itinerary";

/** 项目行程卡属性。无摘要时不渲染. */
export type QuoteTripCardProps = {
  summary: QuoteBudgetItinerarySummary | null;
  /** 当前核价版本状态，用于标题后的定稿标签。 */
  budgetStatus?: string;
  canView?: boolean;
  canEdit?: boolean;
};

const ITINERARY_STATUS_TEXT: Record<string, string> = {
  draft: "草稿",
  confirmed: "已确认",
  finalized: "已固化",
  archived: "已归档",
};

/** 将行程状态码转换为页面中文。 */
function itineraryStatusText(status: string): string {
  return ITINERARY_STATUS_TEXT[status] ?? status;
}

/** 项目行程卡：展示固化行程标题、日期区间与状态，供核价时定位项目背景. */
export function QuoteTripCard({ summary, budgetStatus, canView, canEdit }: QuoteTripCardProps) {
  if (!summary) {
    return null;
  }
  const range = [summary.startDate, summary.endDate].filter(Boolean).join(" ~ ");
  const finalized = budgetStatus === "finalized";
  return (
    <section className="quote-budget-trip-card" aria-label="项目行程">
      <div className="quote-budget-trip-card__label">项目行程</div>
      <div className="quote-budget-trip-card__title-row">
        <h2 className="quote-budget-trip-card__title">{summary.title}</h2>
        {budgetStatus ? <Tag color={finalized ? "green" : "gray"}>{finalized ? "已定稿" : "未定稿"}</Tag> : null}
      </div>
      <div className="quote-budget-trip-card__meta">
        {range ? <span>{range}</span> : null}
        {summary.status ? <span>{itineraryStatusText(summary.status)}</span> : null}
      </div>
      <div className="quote-budget-trip-card__links">
        {canView ? <a href={buildItineraryPreviewPath(summary.itineraryId)} target="_blank" rel="noopener noreferrer">查看行程（新标签页）</a> : null}
        {canEdit ? <a href={buildItineraryEditPath(summary.itineraryId)} target="_blank" rel="noopener noreferrer">编辑行程（新标签页）</a> : null}
      </div>
    </section>
  );
}
